export default [
  {
    text: 'About Aradhna',
    to: 'about',
    subLinks: [
      { text: 'Bio', to: '/lab/aradhna-tripati' },
      { text: 'Honors & Awards', to: 'honors-and-awards' },
      { text: 'Videos', to: 'videos' },
      { text: 'Keynotes & Lectures', to: 'keynotes-and-lectures' }
    ]
  },
  {
    text: 'The Lab',
    to: 'lab',
    subLinks: [
      { text: 'Team Star Wars', to: 'team-star-wars' },
      { text: 'Lab Alumni', to: 'alumni' },
      { text: 'Prospective Students', to: 'prospective-students' },
      { text: 'Lab photos', to: 'lab-photos' }
    ]
  },
  {
    text: 'Research',
    to: 'research',
    subLinks: [
      { text: 'Current Projects', to: 'current-projects' },
      { text: 'Publications', to: 'publications' },
      { text: 'Presentations', to: 'presentations' },
      { text: 'Collaborators', to: 'collaborators' }
    ]
  },
  {
    text: 'Engagement',
    to: 'engagement',
    subLinks: [
      { text: 'Outreach', to: 'outreach' },
      { text: 'Community & Policy', to: 'community-and-policy' }
    ]
  },
  {
    text: 'Lab Updates',
    to: 'lab-updates'
  },
  {
    text: 'The Center',
    to: 'diversity-center'
  }
];
